const PriceTypes = {
  FASTPRIS: 1,
  TRAPPE: 2,
};

export default PriceTypes;
